import FlashContext from "components/FlashMessages/FlashContext";
import { LockUnlocked } from "components/icons/generated";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useTypedContext from "hooks/useTypedContext";
import { pluralize } from "shared/Pluralize";
import { SEARCH_TOFU_WORKSPACES } from "shared/Stack/useSearchTofuWorkspaces/gql";
import useUnlockAllTofuWorkspaces from "shared/Stack/useUnlockAllTofuWorkspaces";

type StackWorkspacesUnlockAllButtonProps = {
  stackId: string;
  hasLockedWorkspaces: boolean;
};

const StackWorkspacesUnlockAllButton = ({
  stackId,
  hasLockedWorkspaces,
}: StackWorkspacesUnlockAllButtonProps) => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [unlockAllWorkspaces, { loading }] = useUnlockAllTofuWorkspaces({
    refetchQueries: [SEARCH_TOFU_WORKSPACES],
  });

  const handleClick = () => {
    unlockAllWorkspaces({ stack: stackId }, (data) => {
      const unlockedCount = data?.tofuWorkspaceUnlockAll?.unlockedWorkspaces?.length ?? 0;

      if (unlockedCount > 0) {
        reportSuccess({
          message: `Successfully unlocked ${unlockedCount} ${pluralize("workspace", unlockedCount)}`,
        });
      }
    });
  };

  const isDisabled = loading || !hasLockedWorkspaces;

  const getTooltipContent = () => {
    if (loading) {
      return "Unlocking workspaces...";
    }

    if (!hasLockedWorkspaces) {
      return "No locked workspaces";
    }

    return "Unlock all locked workspaces";
  };

  return (
    <Tooltip
      on={(props) => (
        <Button
          {...props}
          variant="secondary"
          onPress={handleClick}
          startIcon={LockUnlocked}
          disabled={isDisabled}
        >
          Unlock all
        </Button>
      )}
    >
      {getTooltipContent()}
    </Tooltip>
  );
};

export default StackWorkspacesUnlockAllButton;
